import { CanDeactivateFn } from '@angular/router';

/**
 * Components that hold unsaved edits implement this so the
 * unsavedChangesGuard can ask them before allowing navigation away.
 */
export interface CanComponentDeactivate {
  hasUnsavedChanges(): boolean;
}

/**
 * Functional CanDeactivate guard. If the leaving component reports
 * unsaved changes, prompt the user; otherwise allow navigation.
 */
export const unsavedChangesGuard: CanDeactivateFn<CanComponentDeactivate> = component => {
  if (component?.hasUnsavedChanges?.()) {
    return confirm('You have unsaved changes. Leave without saving?');
  }
  return true;
};
